import ClientLogger from '../util/clientLogger';
import * as MessageReader from '@homeaway/stab-message-reader';
const CATEGORY = 'messages';

// LEX Abacus tests
let overrideKeys = {};

/**
 * Loads lingua messages for an specific locale, it sets same locale for MessageReader
 * @param locale
 * @returns {Promise<any>}
 */
function load(locale) {
    MessageReader.setLocale(locale);
    return import(
        /* webpackInclude: /\.js$/ */
        /* webpackChunkName: "react-lex-[request]" */
        `../lingua/compiled/${locale}`
    ).catch((error) => {
        ClientLogger.logError(`Unexpected error while trying to load lingua keys error=${error}`);
    });
}

/**
 * Loads the singleton variables of lingua from /config and one passed as props
 * @param overrideableKeys Object containing key/flag pairs from Abacus tests
 */
function loadLinguaExperiments(overrideableKeys) {
    overrideKeys = overrideableKeys;
}

/**
 * Read a message via a key and variable options object
 * @param key String
 * @param options Object containing name/value pairs
 * @category lingua key category
 */
function read(key, options, category) {

    if (overrideKeys && overrideKeys[key]) {
        return overrideKeys[key];
    }

    if (typeof category === 'undefined') {
        return MessageReader.read(key, options, CATEGORY);
    }
    /* istanbul ignore next */
    return MessageReader.read(key, options, category);
}

/**
 * Determine if a key is supported for the current locale
 * @param key String
 * @return keyExists Boolean
 */
function exists(key) {
    return MessageReader.exists(key, CATEGORY);
}

export {
    exists,
    load,
    read,
    loadLinguaExperiments
};
